export default __webpack_public_path__ + "static/media/LEVEL6.d87d8e0a.png";